"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductionAuthorEnv = exports.acceptAuthorEnvType = exports.authorEnvRunnerTypeForAuthorEnv = exports.AuthorEnvType = exports.authorEnvForMainInPlatformUnitTest = exports.authorEnvForExamSuite = exports.authorEnvForDevDraftUser = exports.authorEnvForMainRuntime = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
const AuthorEnvForMainRuntime = 'main'; // change to "wranggle" or "wranggleMain" or "wain"  ?
const DefaultAuthorEnvForMainInPlatformUnitTest = 'mainTest'; // to mainInTest or mainInPlatformTest ?
function authorEnvForMainRuntime() {
    let res = (typeof process !== 'undefined' && process.env[constants_iso_1.EnvVarName.AuthorEnvForMain]) || AuthorEnvForMainRuntime;
    res = res.replace(/%/g, '$');
    return res;
}
exports.authorEnvForMainRuntime = authorEnvForMainRuntime;
function authorEnvForDevDraftUser(userUid) {
    return `draft_${userUid}`;
}
exports.authorEnvForDevDraftUser = authorEnvForDevDraftUser;
function authorEnvForExamSuite(examSuiteUid) {
    return `draft_${examSuiteUid}`;
}
exports.authorEnvForExamSuite = authorEnvForExamSuite;
function authorEnvForMainInPlatformUnitTest() {
    let res = authorEnvForMainRuntime();
    if (res.toLowerCase().indexOf('test') >= 0) {
        return res;
    }
    else {
        return DefaultAuthorEnvForMainInPlatformUnitTest;
    }
}
exports.authorEnvForMainInPlatformUnitTest = authorEnvForMainInPlatformUnitTest;
var AuthorEnvType;
(function (AuthorEnvType) {
    AuthorEnvType["Production"] = "prod";
    AuthorEnvType["Draft"] = "draft";
})(AuthorEnvType = exports.AuthorEnvType || (exports.AuthorEnvType = {}));
function authorEnvRunnerTypeForAuthorEnv(authorEnv) {
    return isProductionAuthorEnv(authorEnv) ? AuthorEnvType.Production : AuthorEnvType.Draft;
}
exports.authorEnvRunnerTypeForAuthorEnv = authorEnvRunnerTypeForAuthorEnv;
function acceptAuthorEnvType(actualAuthEnv, authorEnvTypeAccepted) {
    if (authorEnvTypeAccepted === constants_iso_1.AuthorEnvTypeAccepted.Any) {
        return true;
    }
    const actualEnvType = authorEnvRunnerTypeForAuthorEnv(actualAuthEnv);
    return (actualEnvType === AuthorEnvType.Production && authorEnvTypeAccepted === constants_iso_1.AuthorEnvTypeAccepted.ProductionOnly) ||
        (actualEnvType === AuthorEnvType.Draft && authorEnvTypeAccepted === constants_iso_1.AuthorEnvTypeAccepted.DraftOnly);
}
exports.acceptAuthorEnvType = acceptAuthorEnvType;
function isProductionAuthorEnv(authorEnv) {
    return authorEnv === authorEnvForMainRuntime();
}
exports.isProductionAuthorEnv = isProductionAuthorEnv;
//# sourceMappingURL=author-env.js.map